import axios from 'axios';

export namespace Api {
  export const getBranding = () => {
    const req = {
      method: 'GET',
      url: `${process.env.PUBLIC_URL}/branding`,
    };

    return axios(req);
  };
}